import { Typography, withStyles, styled } from "@material-ui/core";

export const Title1 = withStyles((theme) => ({
  root: {
    fontSize: 30,
    color: theme.palette.primary.main,
    fontFamily: "Raleway",
  },
}))((props: any) => <Typography component="h1" {...props} />);

export const TypographyOverflow = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const PageTitle = withStyles((theme: any) => ({
  root: {
    fontSize: "0.9rem",
    lineHeight: "1rem",
    fontWeight: 500,
    color: theme.palette.gray.dark,
    padding: theme.spacing(2, 0),
  },
}))((props: any) => <Typography component="h2" {...props} />);

export const SectionTitle = withStyles((theme) => ({
  root: {
    fontSize: "0.9rem",
    lineHeight: "1rem",
    fontWeight: 700,
    padding: theme.spacing(1, 0, 2, 0),
  },
}))((props: any) => <Typography component="h3" {...props} />);
